<iotnet-map-popover
  icon="assets/images/icons/icon-info.svg"
  [buttonTitle]="'Iotnet.Info.Title' | translate"
  attach="bottom"
>
  <div class="map-info__panel">
    <div class="map-info__heading">{{ "Iotnet.Info.RangeHeading" | translate }}</div>
    <p class="map-info__text">{{ "Iotnet.Info.RangeDisclaimer" | translate }}</p>
  </div>
</iotnet-map-popover>
